import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { IRootAppStore } from '../RootAppStore';

const useAppStore = (): IRootAppStore => useContext(MobXProviderContext).rootAppStore;

export default useAppStore;
